import React from "react";

export function StatCard({ label, value, icon: Icon, accent = "emerald", testid, sub }) {
  const colors = {
    emerald: "text-teal-600 bg-teal-50",
    teal: "text-teal-600 bg-teal-50",
    amber: "text-amber-600 bg-amber-50",
    indigo: "text-indigo-600 bg-indigo-50",
    royal: "text-[#2563EB] bg-[#EAF2FF]",
    navy: "text-[#0B223D] bg-[#EAF2FF]",
    rose: "text-rose-600 bg-rose-50",
  }[accent];
  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 hover:shadow-lg hover:shadow-slate-900/5 transition-shadow" data-testid={testid}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{label}</p>
          <p className="mt-2 font-mono-num font-extrabold text-2xl text-[#0B223D]">{value}</p>
          {sub && <p className="text-xs text-slate-400 mt-1">{sub}</p>}
        </div>
        {Icon && (
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${colors}`}>
            <Icon className="w-5 h-5" />
          </div>
        )}
      </div>
    </div>
  );
}
